import * as actions from './actions'
import reducer from './reducers'
import * as selectors from './selectors'
import * as constants from './consts'
import userSaga from './sagas'

export default {
  actions,
  reducer,
  constants,
  selectors,
  sagas: userSaga,
}
